import { memo } from "react";
import { formatCurrency, transformDateToLocalDateString } from "helpers";
import Tooltip from "ui/components/Tooltip/Tooltip";

export interface ContractCellContract {
  contractNumber?: string | null;
  contractDate?: Date | null;
  status?: { id: string; name: string; color: string } | null;
  netPrice?: number | null;
  sellingPrice?: number | null;
  depositAmount?: number | null;
}

export interface ContractCellProps {
  contract: ContractCellContract | null | undefined;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const ContractCell: React.FC<ContractCellProps> = ({ contract, onClick }) => {
  if (!contract || !contract.contractNumber) return <></>;

  return (
    <Tooltip
      decorate={
        <div
          className="text-sm font-medium text-sky-600 hover:text-sky-900 cursor-pointer truncate"
          onClick={onClick}
        >
          {contract.contractNumber}
        </div>
      }
      position="bottom-left"
      size="medium"
    >
        <div className="min-w-[220px]">
          <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Detalji ugovora</div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Broj ugovora</span>
            <span className="font-medium">{contract.contractNumber}</span>
          </div>
          {/* {contract.status && (
            <div className="flex justify-between text-sm mb-1 items-center">
              <span className="text-slate-300">Status</span>
              <Badge
                text={contract.status.name}
                variant={getStatusBadgeVariant(contract.status.color)}
                height="small"
                showDot={true}
              />
            </div>
          )} */}
          {contract.contractDate && (
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Datum ugovora</span>
              <span className="font-medium">{transformDateToLocalDateString(contract.contractDate)}</span>
            </div>
          )}
          {((contract.netPrice != null && contract.netPrice > 0) || (contract.sellingPrice != null && contract.sellingPrice > 0)) && (
            <>
              <div className="border-t border-slate-600 my-2"></div>
              {contract.netPrice != null && contract.netPrice > 0 && (
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-slate-300">Neto cijena</span>
                  <span className="font-medium">{formatCurrency.format(contract.netPrice)}</span>
                </div>
              )}
              {contract.sellingPrice != null && contract.sellingPrice > 0 && (
                <div className="flex justify-between text-sm">
                  <span className="text-slate-300">Prodajna cijena</span>
                  <span className="font-bold text-green-400">{formatCurrency.format(contract.sellingPrice)}</span>
                </div>
              )}
              {contract.depositAmount != null && contract.depositAmount > 0 && (
                <div className="flex justify-between text-sm mt-1">
                  <span className="text-slate-300">Kapara</span>
                  <span className="font-medium text-amber-400">{formatCurrency.format(contract.depositAmount)}</span>
                </div>
              )}
            </>
          )}
        </div>
      </Tooltip>
  );
};

export default memo(ContractCell);
